import { Formula } from './IFormula';

export enum FieldType {
  Number = 'Number',
  String = 'String',
  Structure = 'Structure', // add server fix
  ID = 'ID',
  // Computed = 'Computed', deprecated
  Date = 'Date',
}

export interface ITextCategories {
  value: number | string;
  count: number;
}

export interface IDatasetMetaStatistics {
  min: number;
  max: number;
  missingValues: number;
  histogramStep: number;
  histogram: number[];
  textCategories: ITextCategories[] | null;
}

export interface IDatasetMetaField {
  name: string;
  type: FieldType;
  statistics?: IDatasetMetaStatistics; // available only for FieldType.Number or FieldType.Date
  formula?: Formula;
  isDiscreteColumn: boolean;
  meta?: {
    isComputed?: boolean;
  };
}

export interface IDatasetMetaModel {
  _id: any;
  fields: IDatasetMetaField[];
  rowCount: number;
  fileName: string;
  fileSize: number;
  missingValues: number;
  updatedAt: Date;
  createdAt: Date;
  scoringTemplateId: string;
  scoringTemplateName?: string;
  isUploaded?: boolean; // UI field
}
